var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.767,
    height: 48.001,
    viewBox: "0 0 36.767 48.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.143,37.881C27.321,31.805,33.1,22.072,33.1,14.717a14.718,14.718,0,0,0-29.435,0c0,7.357,5.783,17.094,9.961,23.168C6.3,38.391,0,40.074,0,42.858,0,46.235,9.248,48,18.383,48s18.384-1.766,18.384-5.143C36.767,40.075,30.474,38.387,23.143,37.881ZM5.121,14.717a13.264,13.264,0,0,1,26.527,0c0,9.492-10.665,23.852-13.264,27.209C15.786,38.569,5.121,24.213,5.121,14.717ZM18.383,46.546c-10.334,0-16.929-2.184-16.929-3.688,0-1.309,5.03-3.123,13.155-3.57,1.741,2.449,3.039,4.063,3.209,4.273a.729.729,0,0,0,1.129,0c.17-.211,1.469-1.826,3.213-4.277,8.125.447,13.151,2.266,13.151,3.574C35.313,44.362,28.718,46.546,18.383,46.546Z",
    fill: "#1a171b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.383,14.848a8,8,0,1,0-8,8A8.009,8.009,0,0,0,26.383,14.848Zm-14.545,0a6.546,6.546,0,1,1,6.545,6.545A6.555,6.555,0,0,1,11.838,14.848Z",
    fill: "#1a171b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.50dd3998e01a0836111f69820915f892.svg";
export { ForwardRef as ReactComponent };